import { createFileRoute } from '@tanstack/react-router';
import { List } from 'antd';
import { FeedShell, IdeaRow, feedSearchSchema } from '../../../features/ideas';

const FeedPage = () => {
  return (
    <FeedShell
      renderList={(ideas) => (
        <List split={false}>
          {ideas.map((idea, i) => (
            <IdeaRow key={idea.id} idea={idea} index={i} />
          ))}
        </List>
      )}
    />
  );
};

export const Route = createFileRoute('/_auth/_feed/ideas')({
  validateSearch: feedSearchSchema,
  component: FeedPage,
});
